import React from "react";
import { Box, Typography, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Paper } from "@mui/material";
import { Icon } from "@iconify/react";

const BlacklistResults = ({ data }) => {
  if (!data || !data.result) return <Typography>No data available</Typography>;

  const { domain, grades, result } = data;
  const { domainResults, mailServerResults } = result;

  // Grade Badge Color
  const getGradeColor = (grade) => {
    switch (grade) {
      case "A":
        return "success";
      case "B":
        return "warning";
      case "C":
      case "D":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, width: "100%", maxWidth: 900, margin: '0 auto' }}>
      <Box p={3}>
        {/* Header */}
        <Typography variant="h4" fontWeight="bold" color="rgb(0, 145, 70)" gutterBottom>
          <Icon icon="tdesign:system-blocked" width={45} height={45} style={{ marginRight: "10px" }} />
          Blacklist Scan Report
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Scan Results for <b>{domain}</b> - Checked on {new Date(data.date).toLocaleString()}
        </Typography>

        {/* Grade Section */}
        <Card sx={{ mt: 2, mb: 3, backgroundColor: "#f9f9f9", boxShadow: "none" }}>
          <CardContent>
            <Typography variant="h6" fontWeight="bold">
              Blacklist Grade:
              <Chip label={grades.blacklistGrade} color={getGradeColor(grades.blacklistGrade)} sx={{ ml: 1, fontSize: "16px" }} />
            </Typography>
          </CardContent>
        </Card>

        {/* Domain Results Table */}
        <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
          Domain Blacklist Check
        </Typography>
        <TableContainer component={Card} sx={{ mt: 1, boxShadow: "none" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f1f1f1" }}>
                <TableCell><b>Domain</b></TableCell>
                <TableCell><b>IP Address</b></TableCell>
                <TableCell><b>Blacklisted</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {domainResults.map((record, index) => (
                <TableRow key={index}>
                  <TableCell>{record.input}</TableCell>
                  <TableCell>{record.ip}</TableCell>
                  <TableCell>
                    <Chip
                      label={record.blacklisted ? "Yes" : "No"}
                      color={record.blacklisted ? "error" : "success"}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mail Server Results Table */}
        <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
          Mail Server Blacklist Check
        </Typography>
        <TableContainer component={Card} sx={{ mt: 1, boxShadow: "none" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f1f1f1" }}>
                <TableCell><b>Mail Server</b></TableCell>
                <TableCell><b>IP Address</b></TableCell>
                <TableCell><b>Blacklisted</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mailServerResults.map((record, index) => (
                <TableRow key={index}>
                  <TableCell>{record.input}</TableCell>
                  <TableCell>{record.ip}</TableCell>
                  <TableCell>
                    <Chip
                      label={record.blacklisted ? "Yes" : "No"}
                      color={record.blacklisted ? "error" : "success"}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>

  );
};

export default BlacklistResults;
